var image_viewer_rtlignore_default = {
  "fontElementMap": "SRGhq",
  "imageContainer": "Vo8es",
  "expandButton": "dUpMr",
  "expandIcon": "SWf0T",
  "pointer": "QF0jn",
  "imageWrapper": "q7zze",
  "imageRatio": "_9-1CJ",
  "image": "FZAyp",
  "imageOverlay": "D0XJh",
  "imagePreload": "NRTr4",
  "imageHighres": "WfAMw",
  "onlyHighRes": "xdIxs",
  "image_loading": "r84aR"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
